import { Link } from 'react-router-dom';
import { postListFetcher } from '@/shared/api/list';
import type { WeekSchedule } from '@/shared/lib/schedule';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import { ScheduleCell } from '@/shared/ui/list/ScheduleCell';
import { ToggleCell } from '@/shared/ui/list/ToggleCell';
import type { ListPageConfig } from '@/shared/ui/list/types';
import { savePartServiceStatus, type PartService } from './api';

const LIST_KEY = 'parts-points';

interface Point extends PartService, Record<string, unknown> {
  name?: string;
  address?: string;
  schedule?: WeekSchedule;
  phone?: string;
  status?: number;
}

const POINT_TYPE_OPTIONS = [
  { value: '0', label: 'ПВЗ' },
  { value: '1', label: 'Юр. лица' },
];

const config: ListPageConfig<Point> = {
  queryKey: LIST_KEY,
  title: 'Адреса доставки',
  errorText: 'Ошибка загрузки адресов доставки',
  fetchList: postListFetcher('/part/service/list/'),
  rows: ['data'],
  searchKeys: [{ value: 'service_id', label: 'Поиск по id сервиса' }],
  filters: [
    { name: 'point_type', label: 'Тип', kind: 'select', options: POINT_TYPE_OPTIONS, clientOnly: true },
  ],
  // Legacy shows ПВЗ and legal entities on separate tabs (filtered on the client).
  selectRows: (rows, { applied }) =>
    applied.point_type === ''
      ? rows
      : rows.filter((row) => String(Number(row.is_legal_entity)) === applied.point_type),
  columns: [
    { header: '№', render: (_, { number }) => number },
    { header: 'ID СТО', render: (point) => <Link to={`/users/user/${point.id}`}>{point.id}</Link> },
    { header: 'Название СТО / Юрлица', render: (point) => point.name },
    { header: 'Адрес', render: (point) => point.address },
    { header: 'График работы', render: (point) => <ScheduleCell schedule={point.schedule} /> },
    { header: 'Телефон', render: (point) => point.phone },
    { header: 'Контактное лицо', render: (point) => point.part_contact },
    { header: 'Контактный телефон', render: (point) => point.part_phone },
    {
      header: 'Статус',
      render: (point) => (
        <ToggleCell
          checked={Boolean(point.status)}
          listKey={LIST_KEY}
          toggle={(next) => savePartServiceStatus(point, next)}
        />
      ),
    },
  ],
};

export const PointsPage = () => <GenericListPage config={config} />;
